import { config } from '@/utils/configuration/config'
import FuelTypeRepoFirebase from "@/repositories/fuelTypes/FuelTypeRepoFirebase"
import FuelType from "@/model/FuelType"
import FuelConsum from '@/model/FuelConsum'
import Ship from "@/model/Ship"
import { NeobuqModification } from '@/model/Neobuq/NeobuqModifications'

class FuelTypeService{
    private static instance: FuelTypeService;
    private fuelTypes: Map<string, FuelType>;
    private repo: FuelTypeRepoFirebase;
    private getAllTypes: boolean;

    private constructor(){
        this.repo = new FuelTypeRepoFirebase();
        this.fuelTypes = new Map<string, FuelType>();
        this.getAllTypes = false
    }

    public static getInstance(): FuelTypeService {
        if (!FuelTypeService.instance) {
            FuelTypeService.instance = new FuelTypeService();
        }

        return FuelTypeService.instance;
    }

    private getRef(ref: string,  consumption: number, ship: Ship) {
        if(!this.fuelTypes.has(ref) && this.repo) {
            //console.log("FuelTypeService - Vamos al repo a buscar el tipo", ref)
            //console.log("Callback: " + this.foundTypeCallback)
            this.repo.getFuelType(ref, ship, this.foundTypeCallback)
        } else {
            this.foundTypeCallback(ref, consumption, ship, this.fuelTypes.get(ref)!)
        }
    }

    private getRefMod(ref: string,  consumption: number,  modification: NeobuqModification) {

        if(!this.fuelTypes.has(ref) && this.repo) {
            //console.log("FuelTypeService - Vamos al repo a buscar el tipo", ref)
            //console.log("Callback: " + this.foundTypeCallbackMod)
            this.repo.getFuelType(ref, modification, this.foundTypeCallbackMod)

        }else{
            this.foundTypeCallbackMod(ref, consumption, modification, this.fuelTypes.get(ref)!)
        }

    }

    private foundTypeCallback(ref: string,  consumption: number, ship: Ship, typeElement: FuelType){

        FuelTypeService.getInstance().fuelTypes.set(ref, typeElement) 

        const objFuelConsum : FuelConsum = new FuelConsum()
        objFuelConsum.fuel = typeElement
        objFuelConsum.consumption = consumption
        
        ship.fuelConsumption.push(objFuelConsum)  
    }

    private foundTypeCallbackMod(ref: string,  consumption: number, modification: NeobuqModification, typeElement: FuelType){

        FuelTypeService.getInstance().fuelTypes.set(ref, typeElement)

        const objFuelConsum : FuelConsum = new FuelConsum()
        objFuelConsum.fuel = typeElement
        objFuelConsum.consumption = consumption
        
        modification.newFuelConsumption.push(objFuelConsum)  
    }

    public static AddFuelTypeToShip(ref: string, consumption: number, ship: Ship) {
        //console.log("ref: " + ref)
        this.getInstance().getRef(ref, consumption, ship);
    }

    public static AddFuelTypeToModification(ref: string, consumption: number, modification: NeobuqModification ){

        //console.log("ref: " + ref)
        this.getInstance().getRefMod(ref, consumption, modification);
    }

    public getTypes(types: Array<Object>){
        if (FuelTypeService.getInstance().getAllTypes) {
            //console.log("Ya debemos tener los tipos")
            FuelTypeService.getInstance().fuelTypes.forEach(element => {
                const objForWindow = {
                    id: element.id,
                    name: element.name,
                }
                types.push(objForWindow);
            })
        } else {
            //console.log("Creo que todavía no tenemos los tipos")
            this.repo.getAllTypes(types, this.addNewFuelTypeFromRepo);
            FuelTypeService.getInstance().getAllTypes = true
        }
    }

    private addNewFuelTypeFromRepo(types: Array<Object>, doc: FuelType) {
        const objForWindow = {
            id: doc.id,
            name: doc.name,
        }
        types.push(objForWindow)

        FuelTypeService.getInstance().fuelTypes.set(doc.id, doc) 
        //console.log("Nuevo tipo de combustible recibido", doc)
    }

}

export default FuelTypeService